import {StyleSheet} from "aphrodite";

import {color, fade, spacing} from "@khanacademy/wonder-blocks-tokens";

// For some reason importing this from the guide repo is failing.
const GuideColors = {
    darkPurple: color.eggplant,
    lightPurple: "#DCBBDA",
    peach: "#F7F3FF",
    pink: "#F5CFFF",
} as const;

export const styles = StyleSheet.create({
    highlight: {
        display: "inline",
        position: "relative",
        font: "inherit",
        lineHeight: "inherit",
        margin: "inherit",
        padding: "inherit",
        color: "currentColor",
        height: "100%",
        backgroundColor: fade(color.purple, 0.1),
        "@media print": {
            background: "none",
            backgroundColor: "transparent",
        },
    },
    cursorLine: {
        color: GuideColors.darkPurple,
        width: 0,
        outline: `1px solid ${GuideColors.darkPurple}`,
        position: "relative",
        pointerEvents: "none",
        userSelect: "none",
    },
    cursorLabel: {
        position: "absolute",
        top: -2,
        insetInlineEnd: 0,
        fontFamily: "Lato, sans-serif",
        fontSize: 11,
        lineHeight: "1.8em",
        height: "1.8em",
        fontWeight: "bold",
        pointerEvents: "none",
        userSelect: "none",
        padding: `0 ${spacing.xxxxSmall_2}px`,
        color: color.white,
        backgroundColor: GuideColors.darkPurple,
        transform: "translate(100%, -100%)",
        borderStartEndRadius: spacing.xxxSmall_4,
        borderEndEndRadius: spacing.xxxSmall_4,
        borderStartStartRadius: spacing.xxxSmall_4,
    },
});
